import * as React from 'react';
import Table from 'react-bootstrap/Table';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import PersonAddOutlinedIcon from '@mui/icons-material/PersonAddOutlined';
import Pagination from '@mui/material/Pagination';
import { NavLink } from 'react-router-dom';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import { postRequest } from '../../lib/api';
import { AuthContext } from '../../authContext/context';
import { useContext, useEffect, useRef, useState } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Swal from 'sweetalert2';
import BreadcrumbsWrapper from '../../components/breadcrumbs'
import { useParams , useLocation, useSearchParams, useNavigate } from 'react-router-dom';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import OutlinedInput from '@mui/material/OutlinedInput';
import ListItemText from '@mui/material/ListItemText';
import Checkbox from '@mui/material/Checkbox';
import FormHelperText from '@mui/material/FormHelperText';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import { pink } from '@mui/material/colors';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { useForm, Controller } from 'react-hook-form';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Alert from '@mui/material/Alert';

export const Wills=()=> {

  const [customerData, setCustomerData] = useState(null);
  const [groupCodes, setGroupCodes] = useState([]);
  const [customerList, setCustomerList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [overrideDate, setOverrideDate] = useState('');
const [selectedServiceType, setSelectedServiceType] = useState('');
const [selectedApproximateValue, setSelectedApproximateValue] = useState('');
const [address1, setAddress1] = useState('');
const [address2, setAddress2] = useState('');
const [town, setTown] = useState('');
const [country, setCountry] = useState('');
const [postcode, setPostcode] = useState('');
const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);
const [selectedCustomerIds, setSelectedCustomerIds] = useState([]);
const [customerObjectId, setCustomerObjectId] = useState(null);
const [lenderPanels, setLenderPanels] = useState([]);
const [partners, setPartners] = useState([]);
const [isPostcodeValid, setIsPostcodeValid] = useState(false);
const [postcodeError, setPostcodeError] = useState('');
const [postcodeMatch, setPostcodeMatch] = useState(null);
const [checkingPostcode, setCheckingPostcode] = useState(false);


const {
  handleSubmit,
  control,
  reset,
  formState: { errors },
  setValue,
  watch,
} = useForm({
  defaultValues: {
    group_code: '',
    acquisition: 'Inbound',
    net_value: '',
    about: [], // ✅ add this
    lender_panel_id: '',
    partner_id: '',
  },
  mode: 'onTouched',
});


const aboutOptions = [
  {
    label: "Do you wish to leave the whole of your estate to your spouse/civil partner?",
    helpText: ""
  },
  {
    label: "Do you own more than one property?",
    helpText: "We recommend that you discuss your options on how you can protect the property from the potential risk of care home fees or in case of a divorce in the family."
  },
  {
    label: "Do you wish to leave any assets to your grandchildren or minor children?",
    helpText: "You may benefit from further advice on Will trusts to ensure that your beneficiaries will receive their inheritance when they are mature enough."
  },
  {
    label: "Do you wish to exclude any of your relatives from your Will?",
    helpText: "Our experts will advise you on how you could reduce the risk of your Will being challenged by disinherited relatives."
  },
  {
    label: "Do you have any Foreign Assets?",
    helpText: ""
  },
  {
    label: "Will there be more than 5 beneficiaries?",
    helpText: ""
  },
  {
    label: "Would you like to leave the right to usage of your property to someone?",
    helpText: ""
  }
];



  // Search states
  const [searchFields, setSearchFields] = useState({
    id: '',
    name: '',
    email: '',
    phone: '',
  });

  const authCtx = useContext(AuthContext);
  const navigate = useNavigate();
  const debounceRef = useRef();
    const { customerId, slug } = useParams();
      const location = useLocation()
       const productId = location.state?.productId;

  // Get customerId from URL query params
  const [searchParams] = useSearchParams();
  const customerIdFromUrl = searchParams.get('customerId');

  // Fetch customers
  const fetchCustomers = async (payloadFields = searchFields, pageVal = page) => {
    const payload = {
      ...payloadFields,
      page: pageVal,
      limit: 5,
    };

    setLoading(true);
    try {
      const response = await postRequest('private/customerList', payload, authCtx.token);
      if (response?.data) {
        setCustomerList(response.data.docs || []);
        setTotalPages(response.data.totalPages || 1);
      } else {
        setCustomerList([]);
        setTotalPages(1);
      }
    } catch (err) {
      setCustomerList([]);
      setTotalPages(1);
    } finally {
      setLoading(false);
    }
  };
  const handleCheckboxChange = (label) => {
  setSelectedCheckboxes((prev) =>
    prev.includes(label)
      ? prev.filter((item) => item !== label)
      : [...prev, label]
  );
};


  // On initial load and page change
  useEffect(() => {
    fetchCustomers(searchFields, page);
    // eslint-disable-next-line
  }, [page]);

  // Debounced search on fields change
  useEffect(() => {
    setPage(1);
    if (debounceRef.current) clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => {
      fetchCustomers(searchFields, 1);
    }, 400);
    // eslint-disable-next-line
  }, [searchFields]);

  // Handle individual search input change


  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const [age, setAge] = React.useState('');
  

  const handleChange = (event) => {
    setSelectedServiceType(event.target.value);
  };
  const handleChange1 = (event) => {
    setSelectedApproximateValue(event.target.value);
  };

  const [personName, setPersonName] = React.useState([]);

  const fetchGroupCodes = async () => {
    try {
      const res = await postRequest('private/getGroupCodeList', {}, authCtx.token);
      if (res?.status === 200 && Array.isArray(res?.data)) {
        setGroupCodes(res.data);
      }
    } catch (err) {
      console.error("Failed to fetch group codes:", err);
    }
  };

  // Fetch active lender panels
  const fetchActiveLenderPanels = async () => {
    try {
      const response = await postRequest('private/getActiveLenderPanels', {}, authCtx.token);
      if (response?.status === 200 && response?.data) {
        setLenderPanels(response.data);
      }
    } catch (error) {
      console.error('Error fetching lender panels:', error);
    }
  };

  // Fetch partners
  const fetchPartners = async () => {
    try {
      const response = await postRequest('private/partnerList', { page: 1, limit: 100 }, authCtx.token);
      if (response?.status === 200 && response?.data?.docs) {
        setPartners(response.data.docs);
      }
    } catch (error) {
      console.error('Error fetching partners:', error);
    }
  };

  const fetchCustomerDetails = async (id) => {
    try {
      const response = await postRequest(`private/getCustomerIndividualData/${id}`, {}, authCtx.token);
      if (response?.status === 200 && response?.data) {
        setCustomerData(response.data);
      }
    } catch (err) {
      console.error('Error fetching customer details', err);
    }
  };

  useEffect(() => {
    fetchGroupCodes();
    if (customerId) fetchCustomerDetails(customerId);
  }, [customerId]);

  // Fetch active lender panels and partners on mount
  useEffect(() => {
    fetchActiveLenderPanels();
    fetchPartners();
  }, [authCtx.token]);

  // Fetch initial customer from URL and add to customerList
  useEffect(() => {
    const fetchInitialCustomer = async () => {
      if (customerIdFromUrl && authCtx.token && customerList.length === 0) {
        console.log('Fetching initial customer from URL:', customerIdFromUrl);
        try {
          const customerRes = await postRequest(`private/getCustomerIndividualData/${customerIdFromUrl}`, {}, authCtx.token);
          if (customerRes?.data) {
            console.log('Fetched initial customer:', customerRes.data);
            setCustomerList([customerRes.data]);
            // Store the customer's ObjectId for the lead creation
            setCustomerObjectId(customerRes.data._id);
            console.log('Stored customer ObjectId:', customerRes.data._id);
          }
        } catch (err) {
          console.error('Error fetching initial customer:', err);
        }
      }
    };

    fetchInitialCustomer();
  }, [customerIdFromUrl, authCtx.token]);

  // Validate postcode and match with branch
  const validatePostcode = async (postcodeValue) => {
    console.log('🔍 Validating postcode:', postcodeValue);
    setCheckingPostcode(true);

    try {
      // Reset states
      setPostcodeMatch(null);
      setIsPostcodeValid(false);
      setPostcodeError('');

      // STEP 1: Validate postcode exists in UK database
      console.log('📤 Step 1: Validating postcode with UK database');
      const response = await postRequest('private/validatePostcode', { postcode: postcodeValue }, authCtx.token);
      console.log('📡 Step 1 Response:', response);

      // Check if postcode is INVALID
      if (response.success !== true || !response.data) {
        console.log('❌ Step 1 Failed - Invalid postcode');
        setIsPostcodeValid(false);
        setPostcodeError('Invalid UK postcode');
        Swal.fire({
          title: 'Invalid Postcode',
          text: 'Please enter a valid UK postcode. This postcode does not exist in our database.',
          icon: 'error',
          confirmButtonText: 'OK'
        });
        setCheckingPostcode(false);
        return false;
      }

      // STEP 2: Match postcode with branch
      console.log('✅ Step 1 Passed - Valid postcode');
      console.log('🔍 Step 2: Matching postcode with branch');
      const matchRes = await postRequest(
        'private/matchBranchByPostcode',
        { postcode: postcodeValue.trim() },
        authCtx.token
      );
      console.log('📡 Step 2 Response:', matchRes);

      if (matchRes?.data?.matched) {
        // ✅ Branch matched
        console.log('✅ Step 2 Passed - Branch matched:', matchRes.data.branch);
        setPostcodeMatch(matchRes.data.branch);
        setIsPostcodeValid(true);
        setPostcodeError('');
        setCheckingPostcode(false);
        return true;
      } else {
        // ❌ No branch matched
        console.log('❌ Step 2 Failed - No branch matched');
        setIsPostcodeValid(false);
        setPostcodeError('No branch available for this postcode');
        Swal.fire({
          title: 'Branch Not Available',
          text: matchRes?.message || 'No branch is available for this postcode area.',
          icon: 'warning',
          confirmButtonText: 'OK'
        });
        setCheckingPostcode(false);
        return false;
      }

    } catch (error) {
      console.error('❌ Postcode validation error:', error);
      setIsPostcodeValid(false);
      setPostcodeError('Could not validate postcode');
      Swal.fire({
        title: 'Validation Error',
        text: 'Could not validate postcode. Please try again.',
        icon: 'error',
        confirmButtonText: 'OK'
      });
      setCheckingPostcode(false);
      return false;
    }
  };

const onSubmit = async (formData) => {
  // Validate postcode before submission
  if (postcode) {
    const postcodeValue = postcode.trim();
    const isValid = await validatePostcode(postcodeValue);
    if (isValid === false) {
      console.log('❌ Form submission blocked - Invalid postcode');
      return; // Stop form submission
    }
  }

  const created_id = localStorage.getItem('id');

  const payload = {
    ...formData,
    product_id: productId,
    created_id: created_id,
    //override_date: overrideDate,
    service_type: selectedServiceType,
    approximate_value_of_assets:selectedApproximateValue,
    address: {
      address1,
      address2,
      town,
      country,
      postcode,
    },
    customer_ids: customerObjectId ? [customerObjectId] : [],
   // documents: [],
    //details: '',
    lender_panel_id: formData.lender_panel_id || null,
    partner_id: formData.partner_id || null,
    branch_id: postcodeMatch?._id || null, // Add matched branch ID
  };

  console.log(payload , 'payload@123')
  console.log('📌 Matched Branch:', postcodeMatch)

  try {
    const res = await postRequest('private/createLeads', payload, authCtx.token);
    if (res?.status === 'success') {
      Swal.fire('Success', 'Leads created successfully!', 'success').then(() => {
        navigate('/leads');
      });
    } else {
      Swal.fire('Error', res?.message || 'Failed to create leads', 'error');
    }
  } catch (err) {
    Swal.fire('Error', err?.message || 'Something went wrong', 'error');
  }
};



  return (
    <>
      <BreadcrumbsWrapper
                   items={[
                   { label: 'Dashboard', path: '/dashboard' },
                   { label: 'Customers', path: '/customers' },
                    { label: 'Wills', path: '' },
                      ]}
                        />
                       <br></br>
      <div className='page-header pb-3'>
        <h1 className='mt-0 mb-0'>Create {slug} 
          <small className='color-grey'> {customerData ? `${customerData.forename || ''} ${customerData.surname || ''}` : ''}</small>
        </h1>

      </div>

      {/* Search Form */}
      <div className='page-top-formview mb-3'>
        <Form onSubmit={handleSubmit(onSubmit)}>
        <Row>


      
       <Col xs={6}>
                   <h5>Group Code</h5>
                   <Controller
                     name="group_code"
                     control={control}
                     rules={{ required: 'Group Code is required' }}
                     render={({ field }) => (
                       <FormControl fullWidth sx={{ my: 1 }} error={!!errors.group_code}>
                         <InputLabel>Group Code</InputLabel>
                         <Select {...field} label="Group Code">
                           {groupCodes.map((item) => (
                             <MenuItem key={item.code} value={item._id}>
                               {item.name} ({item.code})
                             </MenuItem>
                           ))}
                         </Select>
                         {errors.group_code && (
                           <p style={{ color: 'red', fontSize: '0.8rem' }}>{errors.group_code.message}</p>
                         )}
                       </FormControl>
                     )}
                   />
                 </Col>
           <Col xs={6}>
                     <h5>Acquisition</h5>
                     <Controller
                       name="acquisition"
                       control={control}
                       rules={{ required: 'Acquisition is required' }} // ✅ Added rule
                       render={({ field }) => (
                         <FormControl fullWidth sx={{ my: 1 }} error={!!errors.acquisition}>
                           <InputLabel>Acquisition</InputLabel>
                           <Select {...field} label="Acquisition">
                             <MenuItem value='Inbound'>Inbound</MenuItem>
                             <MenuItem value='Cold-Acquistion'>Cold-Acquistion</MenuItem>
                           </Select>
                           {errors.acquisition && (
                             <p style={{ color: 'red', fontSize: '0.8rem' }}>{errors.acquisition.message}</p>
                           )}
                         </FormControl>
                       )}
                     />
                   </Col>
        
          
       
           <Col xs={12} className='mt-3'>
            <h5>Type of Service </h5>
          
            <Form.Group as={Col} controlId="searchId">

              <FormControl sx={{ my: 1, width: '100%' }} variant="outlined" >
                <InputLabel id="demo-simple-select-label">Type of Service</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={selectedServiceType}
                  label="Group Code"
                  onChange={handleChange}
                >
                  <MenuItem value='single'>Single</MenuItem>
                  <MenuItem value='mirror'>Mirror</MenuItem>
                  <MenuItem value='codicil'>Codicil</MenuItem>
                </Select>
                {/* <FormHelperText className='custom-helper-css red-link-text'>Add Trigger Exception</FormHelperText> */}
              </FormControl>
            </Form.Group>
          </Col>

          <Col xs={12} className='mt-3'>
            <h5>Customer Address</h5>
          </Col>

          <Col xs={12} md={6}>
            <TextField
              label="Line 1"
              variant="outlined"
              fullWidth
              value={address1}
              onChange={(e) => setAddress1(e.target.value)}
              sx={{ mt: 1 }}
            />
          </Col>

          <Col xs={12} md={6}>
            <TextField
              label="Line 2"
              variant="outlined"
              fullWidth
              value={address2}
              onChange={(e) => setAddress2(e.target.value)}
              sx={{ mt: 1 }}
            />
          </Col>

          <Col xs={12} md={6}>
            <TextField
              label="Town"
              variant="outlined"
              fullWidth
              value={town}
              onChange={(e) => setTown(e.target.value)}
              sx={{ mt: 1 }}
            />
          </Col>

          <Col xs={12} md={6}>
            <TextField
              label="Country"
              variant="outlined"
              fullWidth
              value={country}
              onChange={(e) => setCountry(e.target.value)}
              sx={{ mt: 1 }}
            />
          </Col>

          <Col xs={12} md={6}>
            <TextField
              label="Postcode"
              variant="outlined"
              fullWidth
              value={postcode}
              onChange={(e) => {
                setPostcode(e.target.value);
                if (postcodeError) {
                  setPostcodeError('');
                  setIsPostcodeValid(false);
                  setPostcodeMatch(null);
                }
              }}
              onBlur={async (e) => {
                const postcodeValue = e.target.value.trim();
                if (postcodeValue) {
                  console.log('🔍 OnBlur - Validating postcode:', postcodeValue);
                  await validatePostcode(postcodeValue);
                } else {
                  setIsPostcodeValid(false);
                  setPostcodeError('');
                  setPostcodeMatch(null);
                }
              }}
              error={!!postcodeError}
              helperText={
                checkingPostcode
                  ? 'Validating postcode...'
                  : postcodeError
                  ? postcodeError
                  : isPostcodeValid && postcodeMatch
                  ? `✓ Valid postcode - Branch: ${postcodeMatch.name}`
                  : ''
              }
              disabled={checkingPostcode}
              sx={{
                mt: 1,
                '& .MuiFormHelperText-root.Mui-error': {
                  color: '#d32f2f'
                },
                '& .MuiFormHelperText-root:not(.Mui-error)': {
                  color: isPostcodeValid ? '#2e7d32' : 'inherit'
                }
              }}
            />
          </Col>

          <Col xs={12} className='mt-3'>
           
          
         
<Controller
  name="about"
  control={control}
  render={({ field }) => (
    <>
      <h5>About</h5>
      {aboutOptions.map((option) => (
        <div key={option.label} style={{ display: 'block', marginBottom: '16px' }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={field.value.includes(option.label)}
                onChange={(e) => {
                  const newValue = e.target.checked
                    ? [...field.value, option.label]
                    : field.value.filter((val) => val !== option.label);
                  field.onChange(newValue);
                }}
                sx={{
                  '&.Mui-checked': {
                    color: '#764ba2',
                  },
                }}
              />
            }
            label={option.label}
          />
          {option.helpText && field.value.includes(option.label) && (
            <div style={{
              marginLeft: '32px',
              marginTop: '4px',
              color: '#666',
              fontSize: '0.9rem',
              lineHeight: '1.4'
            }}>
              {option.helpText}
            </div>
          )}
        </div>
      ))}
    </>
  )}
/>


          </Col>
          <br></br>
          <br></br>
      
           <Col xs={6}>
            <h5>Approximate Value of Assets</h5>
            <Form.Group as={Col} controlId="searchId">

              <FormControl sx={{ my: 1, width: '100%' }} variant="outlined" >
                <InputLabel id="demo-simple-select-label">Approximate Value of Assets</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={selectedApproximateValue}
                  label="Approximate Value of Assets"
                  onChange={handleChange1}
                >
                 <MenuItem value='Upto £500,000'>Upto £500,000</MenuItem>
                  <MenuItem value='£500,000 - £1,000,000'>£500,000 - £1,000,000</MenuItem>
                  <MenuItem value='Over £1,000,000'>Over £1,000,000</MenuItem>
                </Select>
                {/* <FormHelperText className='custom-helper-css red-link-text'>Add Trigger Exception</FormHelperText> */}
              </FormControl>
            </Form.Group>
          </Col>

        </Row>
        <br></br>

        {/* Lender Panel Section */}
        <Row>
          <Col xs={12} md={6}>
            <h5>Lender Panel</h5>
            <Controller
              name="lender_panel_id"
              control={control}
              render={({ field }) => (
                <FormControl fullWidth sx={{ my: 1 }}>
                  <Select
                    {...field}
                    displayEmpty
                    sx={{ backgroundColor: 'white' }}
                  >
                    <MenuItem value="">
                      <em>Select Lender Panel (Optional)</em>
                    </MenuItem>
                    {lenderPanels.map((panel) => (
                      <MenuItem key={panel._id} value={panel._id}>
                        {panel.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              )}
            />
          </Col>
          <Col xs={12} md={6}>
            <h5>Partner</h5>
            <Controller
              name="partner_id"
              control={control}
              render={({ field }) => (
                <FormControl fullWidth sx={{ my: 1 }}>
                  <Select
                    {...field}
                    displayEmpty
                    sx={{ backgroundColor: 'white' }}
                  >
                    <MenuItem value="">
                      <em>Select Partner (Optional)</em>
                    </MenuItem>
                    {partners.map((partner) => (
                      <MenuItem key={partner._id} value={partner._id}>
                        {partner.name || 'Unknown'}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              )}
            />
          </Col>
        </Row>
        <br></br>


          <Row>

            <Form.Group as={Col} controlId="searchId">

              <FormControl sx={{ my: 1, width: '100%' }} variant="outlined" >
                <Stack spacing={2} direction="row">

                  <Button variant="contained" type="submit" className='red-bg red-button text-capitalize h-56'>Submit</Button>

                </Stack>
              </FormControl>
            </Form.Group>


          </Row>
        </Form>



      </div>

      {/* Table View */}
      <div>


        {/* Pagination */}
        {customerList.length > 0 && (
          <div style={{ display: 'flex', justifyContent: 'center', marginTop: 16 }}>
            <Pagination
              count={totalPages}
              page={page}
              onChange={handlePageChange}
              color="primary"
              shape="rounded"
              size="medium"
              sx={{
                '& .Mui-selected': {
                  backgroundColor: '#bb0000 !important',
                  color: '#fff !important',
                },
                '& .MuiPaginationItem-root': {
                  color: '#bb0000',
                  borderColor: '#bb0000',
                },
              }}
            />
          </div>
        )}
      </div>
    </>
  );
}
